import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaGooglePlay, FaApple } from 'react-icons/fa';

const Footer = () => {
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/#';
  
  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const QuickLinks = () => (
    <>
      {isHomePage ? (
        <ul className="space-y-2">
          <li>
            <a href="#features" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              Features
            </a>
          </li>
          <li>
            <a href="#how-to-play" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              How to Play
            </a>
          </li>
          <li>
            <a href="#about-us" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              About Us
            </a>
          </li>
        </ul>
      ) : (
        <ul className="space-y-2">
          <li>
            <Link to="/#features" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              Features
            </Link>
          </li>
          <li>
            <Link to="/#how-to-play" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              How to Play
            </Link>
          </li>
          <li>
            <Link to="/#about-us" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
              About Us
            </Link>
          </li>
        </ul>
      )}
    </>
  );

  return (
    <footer className="bg-gray-900 text-white py-6 sm:py-8">
      <div className="container mx-auto px-4">
        {/* Footer Grid Layout */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Logo and Branding - Full width on mobile */}
          <div className="col-span-2 sm:col-span-2 md:col-span-1 flex flex-col items-center md:items-start">
            {isHomePage ? (
              <a href="#hero" className="flex items-center mb-4">
                <img
                  src="logoctc2.png"
                  alt="Logo"
                  className="w-auto h-10 sm:h-12 border-b-2 border-r-2 border-white"
                />
                <div className="flex flex-col ml-2 text-sm">
                  <p>Chase</p>
                  <p>the</p>
                  <p>Chickens</p>
                </div>
              </a>
            ) : (
              <Link to="/#hero" className="flex items-center mb-4">
                <img
                  src="logoctc2.png"
                  alt="Logo"
                  className="w-auto h-10 sm:h-12 border-b-2 border-r-2 border-white"
                />
                <div className="flex flex-col ml-2 text-sm">
                  <p>Chase</p>
                  <p>the</p>
                  <p>Chickens</p>
                </div>
              </Link>
            )}
            <p className="text-gray-400 text-center md:text-left">
              Fun and adventure await with Chase the Chickens!
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="col-span-1">
            <h4 className="text-base sm:text-lg font-semibold mb-4">Quick Links</h4>
            <div className="grid grid-cols-2 md:grid-cols-2 gap-x-4">
              <QuickLinks />
              <ul className="space-y-2">
                <li>
                  <Link to="/signin" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                    Sign In
                  </Link>
                </li>
                <li>
                  <Link to="/signup" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                    Sign Up
                  </Link>
                </li>
                <li>
                  <Link to="/download" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                    Download
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="col-span-1">
            <h4 className="text-base sm:text-lg font-semibold mb-4">Socials</h4>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#E57373] text-xl sm:text-2xl"
              >
                <FaFacebook />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#E57373] text-xl sm:text-2xl"
              >
                <FaTwitter />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#E57373] text-xl sm:text-2xl"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Download Section */}
          <div className="col-span-1">
            <h4 className="text-base sm:text-lg font-semibold mb-4">Download</h4>
            <div className="flex flex-col space-y-4">
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-[#E57373] transition-colors duration-200"
              >
                <FaGooglePlay className="text-xl sm:text-2xl" />
                <span>Google Play</span>
              </a>
              <a
                href="https://www.apple.com/app-store/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-[#E57373] transition-colors duration-200"
              >
                <FaApple className="text-xl sm:text-2xl" />
                <span>App Store</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 border-t border-gray-700 pt-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                Cookie Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                Terms of Service
              </Link>
              <Link to="/eula" className="text-gray-400 hover:text-[#E57373] transition-colors duration-200">
                EULA
              </Link>
            </div>

            {/* Back to Top Button */}
            <button
              onClick={handleBackToTop}
              className="bg-[#E57373] hover:bg-[#EF9A9A] text-white rounded-full px-4 py-2 transition duration-200"
            >
              Back to Top
            </button>
          </div>

          {/* Copyright Section */}
          <p className="mt-4 text-gray-400 text-center">
            © 2024 Chase the Chickens. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;